import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import parse from "html-react-parser";
import { useFetchMenuAPI } from "../../custom-hooks/useFetchPagesAPI";

import { scrollWithOffset } from "../../custom-functions/customFunctions";
import LogoToogether from "../../assets/svg/logo-toogether.svg";
import AccessButtonAtm from "../../atoms/access-button/AccessButtonAtm";

type HeaderCpntProps = {
  handleDisplayMemberPopin: () => void;
};

const HeaderCpnt = ({ handleDisplayMemberPopin }: HeaderCpntProps): JSX.Element => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const [isLoading, navmenu, fetchMenuAPI] = useFetchMenuAPI(
    process.env.REACT_APP_API_URL + "/admin/api/singletons/get/Menu"
  );

  const handleBurgerClick = (): void => {
    setMenuIsOpen(!menuIsOpen);
  };

  useEffect(() => {
    fetchMenuAPI();
  }, []);

  return (
    <header className="header">
      <div className="h-container">
        <div className="hc-logo-wrapper">
          <HashLink to="/#accueil" scroll={(el) => scrollWithOffset(el, 300)}>
            <img className="hclw-img" src={LogoToogether} alt="logo Toogether" />
          </HashLink>
        </div>
        <nav className={`hc-navbar ${menuIsOpen && "navbar-open"}`}>
          <ul className="hcn-list">
            <HashLink to="/#nos-valeurs" scroll={(el) => scrollWithOffset(el, 120)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page1 || "Toogether") : "Toogether"}
              </li>
            </HashLink>
            <HashLink to="/#agir" scroll={(el) => scrollWithOffset(el, 120)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page2 || "Agir") : "Agir"}
              </li>
            </HashLink>
            <HashLink to="/#adhérer" scroll={(el) => scrollWithOffset(el, 90)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page3 || "Adhérer") : "Adhérer"}
              </li>
            </HashLink>
            {/* <HashLink to="/#key-numbers" scroll={(el) => scrollWithOffset(el, 300)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page4 || "Nos services") : "Nos services"}
              </li>
            </HashLink> */}
            <HashLink to="/#soutenir" scroll={(el) => scrollWithOffset(el, 150)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page6 || "Soutenir") : "Soutenir"}
              </li>
            </HashLink>
            <HashLink to="/#nous-contacter" scroll={(el) => scrollWithOffset(el, 150)}>
              <li onClick={handleBurgerClick} className="hcnl-item">
                {navmenu ? parse(navmenu.page4 || "Nous contacter") : "Nous contacter"}
              </li>
            </HashLink>
            <AccessButtonAtm onClick={handleBurgerClick} textButton="Faire un don" />
          </ul>
        </nav>

        <div onClick={handleBurgerClick} className={`hc-burger ${menuIsOpen && "burger-cross"}`}>
          <span className="hcb-line"></span>
          <span className="hcb-line"></span>
          <span className="hcb-line"></span>
        </div>
      </div>
    </header>
  );
};

export default HeaderCpnt;
